import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageview } from './trackingClient'

export function useRouteTracker() {
  const location = useLocation()
  const lastPath = useRef('')

  useEffect(() => {
    const path = `${location.pathname}${location.search}`
    if (path === lastPath.current) return
    lastPath.current = path
    trackPageview(path)
  }, [location.pathname, location.search])
}
